// extracted by mini-css-extract-plugin
export default {"fondo":"Detail_fondo__y4VbJ","img":"Detail_img__yXjlG","container":"Detail_container__Aq5Cn","button":"Detail_button__hWNOM"};